import { createContext, useContext, useEffect, useState } from "react";
import { api, apiError } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, object = user
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Returning from Google sign-in: AuthCallback exchanges the session_id first.
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
      setReady(true);
      return;
    }
    const token = localStorage.getItem("token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api.get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("role", r.data.role || ""); })
      .catch(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", data.token);
    localStorage.setItem("role", data.user?.role || "");
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    localStorage.setItem("token", data.token);
    localStorage.setItem("role", data.user?.role || "");
    setUser(data.user);
    return data.user;
  };

  const loginWithGoogleSession = async (sessionId) => {
    const { data } = await api.post("/auth/google/session", { session_id: sessionId });
    adoptSession(data);
    return data.user;
  };

  // Store a {token, user} pair returned by any sign-in style endpoint.
  const adoptSession = (data) => {
    localStorage.setItem("token", data.token);
    localStorage.setItem("role", data.user?.role || "");
    setUser(data.user);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, loginWithGoogleSession, adoptSession, logout, apiError }}>
      {children}
    </AuthContext.Provider>
  );
}
